import moment from 'moment';
import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sold-out-msg',
  templateUrl: './sold-out-msg.component.html',
  styleUrls: ['./sold-out-msg.component.scss']
})
export class SoldOutMsgComponent implements OnChanges {
  @Input() fullCapacityDays: { begin: string, end: string }[];

  public days: string;

  constructor() {
  }

  ngOnChanges() {
    this.days = this.fullCapacityDays.map(({ begin, end }) => {
      if (begin === end) {
        return this._getFormattedDate(begin);
      }

      return this._getFormattedDate(begin) + ' - ' + this._getFormattedDate(end);
    })
      .join(', ');
  }

  private _getFormattedDate(date: string) {
    return moment(date, 'DD.MM.YYYY').format('D. MMM').toLocaleLowerCase();
  }
}
